(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grecook-homepage"] && !Shopify.designMode) return;
  try {
    
if (!window.grecookMegaBound) {
  window.grecookMegaBound = true;
  document.addEventListener('pointerover', (event) => {
    if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
    const summary = event.target.closest('.gc-fan-mega > summary');
    if (summary) {
      document.querySelectorAll('.gc-fan-mega[open]').forEach(menu => { if (menu !== summary.parentElement) menu.open = false; });
      summary.parentElement.open = true;
    }
  });
  document.addEventListener('pointerout', (event) => {
    if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
    const menu = event.target.closest('.gc-fan-mega');
    if (menu && !menu.contains(event.relatedTarget) && !menu.contains(document.activeElement)) menu.open = false;
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.gc-fan-mega > summary');
    if (trigger) document.querySelectorAll('.gc-fan-mega[open]').forEach(menu => { if (menu !== trigger.parentElement) menu.open = false; });
    document.querySelectorAll('.gc-fan-mega[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('.gc-fan-panel a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.gc-fan-mega[open]').forEach(menu => {
      const restoreFocus = menu.contains(document.activeElement);
      menu.open = false;
      if (restoreFocus) menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('focusout', (event) => {
    const menu = event.target.closest('.gc-fan-mega');
    if (menu && !menu.contains(event.relatedTarget)) menu.open = false;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grecook-new-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('grecook-new-product')){
customElements.define('grecook-new-product',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const main=this.querySelector('.gnp-main'),dialog=this.querySelector('dialog');
this.querySelectorAll('[data-gnp-thumb]').forEach(button=>button.addEventListener('click',()=>{
main.srcset='';main.src=button.dataset.src;main.alt=button.dataset.alt;
this.querySelectorAll('[data-gnp-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
}));
this.querySelector('[data-gnp-zoom]')?.addEventListener('click',()=>{dialog.querySelector('img').src=main.currentSrc||main.src;dialog.querySelector('img').alt=main.alt;dialog.showModal();});
this.querySelector('[data-gnp-close]').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
this.querySelector('[data-gnp-variant]')?.addEventListener('change',e=>{const url=new URL(location.href);url.searchParams.set('variant',e.target.value);location.assign(url);});
const source=this.querySelector('.gnp-description');
if(source){
const p=[...source.querySelectorAll('p')].find(p=>p.textContent.trim());
if(p){const target=this.querySelector('.gnp-summary');target.textContent=p.textContent.trim();target.hidden=false;}
const heading=[...source.querySelectorAll('h2,h3')].find(h=>/^(features|key features|highlights|about this item)$/i.test(h.textContent.trim()));
const list=heading?.nextElementSibling;
if(list?.tagName==='UL'){const target=this.querySelector('.gnp-highlights');[...list.children].slice(0,5).forEach(li=>target.querySelector('ul').append(li.cloneNode(true)));target.hidden=false;}
const spec=[...source.querySelectorAll('h2,h3')].find(h=>/^(specifications|technical specifications|key specifications)$/i.test(h.textContent.trim()))?.nextElementSibling;
if(spec&&['TABLE','UL','DL'].includes(spec.tagName)){const target=this.querySelector('.gnp-key');target.querySelector('div').append(spec.cloneNode(true));target.hidden=false;}
}
this.querySelector('[data-gnp-now]')?.addEventListener('click',async e=>{
const form=e.target.closest('form');if(!form.reportValidity())return;
const buttons=[...form.querySelectorAll('button')],error=form.querySelector('.gnp-error');
buttons.forEach(b=>b.disabled=true);error.hidden=true;
try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||this.dataset.error);location.assign(root+'checkout');}
catch(err){error.textContent=err.message||this.dataset.error;error.hidden=false;buttons.forEach(b=>b.disabled=false);}
});
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
